module.exports = __webpack_public_path__ + "static/media/CommentIcon.3d326f54.svg";